import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Transaction } from "../../../models/transacaoPluggy";
import * as transacaoPluggyService from "../../../service/transacaoPluggyService";
import './styles.css';
import Header from "../../../components/Header";
const TransacaoBank = () => {
  const [transacao, setTransacao] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams<{ id: string }>() ?? { id: "" };

  console.log("Id recebido dos parâmetros:", id);

  const loadTransacao = (id: string) => {
    transacaoPluggyService
      .getTransacao(id)
      .then((response) => {
        console.log("Resposta do serviço:", response);
        setTransacao(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados:", error);
      })
      .finally(() => {
        setLoading(false);
        console.log("Finalizado carregamento.");
      });
  };

  useEffect(() => {
    if (id) {
      loadTransacao(id);
    }
  }, [id]);

  return (
    <>
    
   <Header/>
    <div className="container-fluid mt-5 pt-5">
      <h2 className="mb-4 titulo-extrato-pluggy">Extrato Bancário</h2>

      {loading ? (
        <div className="alert alert-info">Carregando transações...</div>
      ) : transacao.length === 0 ? (
        <div className="alert alert-warning">Nenhuma transação encontrada.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="table-dark">
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Valor (R$)</th>
                <th>Categoria</th>
                <th>Status</th>
                <th>Destinatário</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {transacao.map((item, index) => (
                <tr key={index}>
                  <td>{new Date(item.date).toLocaleDateString("pt-BR")}</td>
                  <td>{item.description}</td>
                  <td
                    className={
                      item.amount < 0 ? "negative" : "positive"
                    }
                  >
                    {item.amount.toFixed(2)}
                  </td>

                  <td>{item.category}</td>
                  <td>{item.status}</td>
                  <td>{item.paymentData?.receiver?.name || "N/A"}</td>
                  <td>{item.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
     </>
  );
};

export default TransacaoBank;
